import { jsx } from "react/jsx-runtime";
import DataUsageIcon from "@mui/icons-material/DataUsage";
import { validateTidalLicense } from "../../base/index.js";
function DataUsage(props) {
  return /* @__PURE__ */ jsx(
    DataUsageIcon,
    {
      "data-testid": "DataUsage",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "DataUsage",
      "data-tidal-icon-meta": "miscellaneous"
    }
  );
}
DataUsage.tidalIconMeta = {
  categories: "miscellaneous",
  name: "DataUsage"
};
validateTidalLicense();
export {
  DataUsage
};
//# sourceMappingURL=DataUsage.js.map
